import { createBrowserRouter } from "react-router-dom";
import App from "../App";
// import MainLayout from "../layout/MainLayout"; import {
// TimeDatePickerCalendar,AllBadges,AllButtons,AllDifferentInputType,AllDropDown
// , AllInputs,AllProgressBars,AllTypographys,AllUploadType,AllToasts } from
// "../pages";
import { Main, SingleNews, ContactUs, AboutUs, } from "../components";
import {
    MainAdminWriters,
    MainAdminPublishedNewses,
    MainAdminScheduledArticles,
    MainAdminRejectedNewses,
    MainAdminNewsPendingConfirmation,
    MainAdminNewsCategory,
    MainAdminNewsCategoryAdd,
    MainAdminNewsCategoryEdit,
    MainAdminTagsCategory,
    MainAdminTagsCategoryAdd,
    MainAdminTagsCategoryEdit,
    MainAdminUploadNews,
    MainAdminEditNews,
    MainAdminUploadNewsRelease,
    MainAdminEditNewsRelease,
    MainAdminUploadNewsConfirmation,
    MainAdminDefinitionAdvertising,
    MainAdminSocialNetworks,
    MainAdminAboutUs,
    MainAdminContactUs,
    MainAdminVisits,
    MainAdminIndicators,
    Login,
    Archive,
    ArchiveAllNews,
    Tag,    MainAdminUsers

} from "../components";

import Layout from "../layout/Layout";
import LayoutMainAdmin from "../layout/LayoutMainAdmin";

import NewUILayout from "../layout/NewUILayout";
import HomePage from "../pages/NewUI/HomePage";
export const router = createBrowserRouter([


    {
        path: "/",
        element: <NewUILayout />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        ),
        children: [
            {
                path: '/',
                element: <HomePage />
            }
            , {
                path: '/news/:cat/:id',  
                element: <SingleNews />
            }
        
            ,{
                path: '/contact-us',
                element: <ContactUs />
            }, {
                path: '/archive/:id',
                element: <Archive />
            },
            {
                path: '/archiveAllNews/:id',
                element: <ArchiveAllNews />
            },
            {
                path: '/Tag/:id',
                element: <Tag />
            },
          
            {
                path: '/about-us',
                element: <AboutUs />
            }
        ]
    }, {
        path: "/mainAdmin",
        element: <LayoutMainAdmin />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        ),
        children: [
            {
                path: '/mainAdmin/writers',
                element: <MainAdminWriters />
            },
            {
                path: '/mainAdmin/users',
                element: <MainAdminUsers />
            },
            {
                path: '/mainAdmin/PublishedNewses',
                element: <MainAdminPublishedNewses />
            },
            {
                path: '/mainAdmin/ScheduledNews',
                element: <MainAdminScheduledArticles />
            },
            {
                path: '/mainAdmin/rejectedNewses',
                element: <MainAdminRejectedNewses />
            }, {
                path: '/mainAdmin/newsPendingConfirmation',
                element: <MainAdminNewsPendingConfirmation />
            },
             {
                path: '/mainAdmin/newsCategory',
                element: <MainAdminNewsCategory />,
                children: [
                    {
                        path: '/mainAdmin/newsCategory/add',
                        element: <MainAdminNewsCategoryAdd />
                    }, {
                        path: '/mainAdmin/newsCategory/edit',
                        element: <MainAdminNewsCategoryEdit />
                    }
                ]
            },
            {
                path: '/mainAdmin/tagsCategory',
                element: <MainAdminTagsCategory />,
                children: [
                    {
                        path: '/mainAdmin/tagsCategory/add',
                        element: <MainAdminTagsCategoryAdd />
                    }, {
                        path: '/mainAdmin/tagsCategory/edit',
                        element: <MainAdminTagsCategoryEdit />
                    }
                ]
            }, {
                path: '/mainAdmin/uploadNews',
                element: <MainAdminUploadNews />,
                children: [
                    {
                        path: '/mainAdmin/uploadNews/release',
                        element: <MainAdminUploadNewsRelease />
                    }, {
                        path: '/mainAdmin/uploadNews/confirmation',
                        element: <MainAdminUploadNewsConfirmation />
                    }
                ]
            }, {
                path: '/mainAdmin/editNews',
                element: <MainAdminEditNews />,
                children: [
                    {
                        path: '/mainAdmin/editNews/release',
                        element: <MainAdminEditNewsRelease />
                    }
                ]
            },
            {
                path: '/mainAdmin/definitionAdvertising',
                element: <MainAdminDefinitionAdvertising />
            }, {
                path: '/mainAdmin/socialNetworks',
                element: <MainAdminSocialNetworks />
            }, {
                path: '/mainAdmin/aboutUs',
                element: <MainAdminAboutUs />
            }, {
                path: '/mainAdmin/contactUs',
                element: <MainAdminContactUs />
            }, {
                path: '/mainAdmin/visits',
                element: <MainAdminVisits />
            },
            {
                path: '/mainAdmin/indicators',
                element: <MainAdminIndicators />
            },

        ]
    }, {
        path: "/admin",
        element: <Login />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }
])